export default "__VITE_ASSET__24e08670__"